import { render, staticRenderFns } from "./searchTypeList.vue?vue&type=template&id=1aaf6ddd&scoped=true"
import script from "./searchTypeList.vue?vue&type=script&lang=js"
export * from "./searchTypeList.vue?vue&type=script&lang=js"
import style0 from "./searchTypeList.vue?vue&type=style&index=0&id=1aaf6ddd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaf6ddd",
  null
  
)

export default component.exports